import Head from "next/head";

import { StyleHooks } from "@/src/hook";

interface DisableZoomProps {
  overrideMobile?: boolean;
}

function DisableZoom({ overrideMobile }: DisableZoomProps) {
  const isMobile = StyleHooks.useBreakPointDown("md");

  if (isMobile || overrideMobile) {
    return (
      <Head>
        <meta
          id="disableZoom"
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
      </Head>
    );
  }

  return <></>;
}

export default DisableZoom;
